import React from 'react'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import { makeStyles } from '@material-ui/core/styles'
import { Colors } from '../../Utils/theme'

const useStyles = makeStyles({
  outerContainer: {
    borderBottom: 'none'
  },
  container: {
    borderBottom: 'none'
  },
  cell: {
    height: 40,
    padding: '0 1rem',
    backgroundColor: Colors.tableHeaderBackgroundColor,
    color: Colors.tableHeaderTextColor,
    fontWeight: 700,
    textTransform: 'uppercase'
  },
  firstCell: {
    borderTopLeftRadius: 5,
    borderBottomLeftRadius: 5
  },
  lastCell: {
    borderTopRightRadius: 5,
    borderBottomRightRadius: 5
  }
})

function TableHeader (props) {
  const classes = useStyles()

  return (
    <TableHead className={classes.outerContainer}>
      <TableRow className={classes.container}>
        {props.columnNames.map((columnName, index) => {
          let className = classes.cell
          if (index === 0) className = `${classes.cell} ${classes.firstCell}`
          else if (index === props.columnNames.length - 1) className = `${classes.cell} ${classes.lastCell}`

          return <TableCell key={index} className={className}>{columnName}</TableCell>
        })}
      </TableRow>
    </TableHead>
  )
}

export default TableHeader
